export const EyeClosed = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color='#958B88', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M10.743 5.092C11.149 5.032 11.569 5 12 5c5.105 0 8.455 4.505 9.58 6.287.137.215.205.323.243.49.029.125.029.322 0 .447-.038.166-.107.274-.244.492-.3.474-.757 1.141-1.363 1.865M6.72 6.719c-2.16 1.466-3.625 3.501-4.298 4.566-.137.217-.205.325-.243.492a1.173 1.173 0 000 .446c.038.167.106.274.242.49C3.546 14.495 6.895 19 12 19c2.056 0 3.826-.73 5.282-1.719M6.719 6.72l.005-.004m-.005.004L3 3M6.72 6.719l3.16 3.16m7.41 7.398l-.007.004m0 0l-3.16-3.16m3.16 3.16L21 21M9.88 9.879l4.242 4.242M9.879 9.88a3 3 0 104.243 4.243'
        ></path>
      </svg>
    </span>
  );
};
